module.exports = __webpack_public_path__ + "e0106718/img/pwrd-by-sourcery-black.bba9ba41.svg";